import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=0005c3d2&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=js&"
export * from "./ChatMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005c3d2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatMessageMain: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatMessageMain.vue').default,ChatMessageWelcome: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatMessageWelcome.vue').default})
